import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import type { ReactNode } from "react";

type Props = {
  title: string;
  subtitle: string;
  expanded: boolean;
  onToggle?: () => void;
  trailing?: ReactNode;
};

export default function CoverageAccordionHeader({ title, subtitle, expanded, onToggle, trailing }: Props) {
  const copy = (
    <div className="min-w-0">
      <p className="text-xl font-semibold text-gray-900">{title}</p>
      <p className="text-sm text-gray-500">{subtitle}</p>
    </div>
  );

  if (!onToggle) {
    return (
      <div className="flex w-full items-start gap-3">
        <div className="min-w-0 flex-1">{copy}</div>
        {trailing}
      </div>
    );
  }

  const chevron = expanded ? (
    <ChevronUpIcon className="h-5 w-5" aria-hidden="true" />
  ) : (
    <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
  );

  return (
    <div className="flex w-full items-start gap-3">
      <button
        type="button"
        className="min-w-0 flex-1 cursor-pointer text-left"
        aria-expanded={expanded}
        onClick={onToggle}
      >
        {copy}
      </button>
      {trailing}
      <button
        type="button"
        className="mt-1 shrink-0 cursor-pointer text-gray-500"
        aria-expanded={expanded}
        aria-label={expanded ? `Collapse ${title}` : `Expand ${title}`}
        onClick={onToggle}
      >
        {chevron}
      </button>
    </div>
  );
}
